// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__31P2n","header":"MessagesList_header__XhrQa","chat":"MessagesList_chat__1_Elu"};